if (!customElements.get('back-in-stock-form')) {
  customElements.define(
    'back-in-stock-form',
    class BackInStockForm extends HTMLElement {
      connectedCallback() {
        this.emailInput = this.querySelector('.back-in-stock__input');
        this.formEl = this.querySelector('.back-in-stock__form');
        this.successEl = this.querySelector('.back-in-stock__success');
        this.submitEl = this.querySelector('.back-in-stock__submit');

        this.submitEl?.addEventListener('click', this.onSubmit.bind(this));
        this.submitEl?.addEventListener('keydown', this.onSubmitKeydown.bind(this));
        this.emailInput?.addEventListener('keydown', this.onEmailKeydown.bind(this));

        this._variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.dataset.sectionId) return;
          this.dataset.variantId = event.data.variant?.id ?? '';
          this.resetForm();
        });

        const init = () => {
          const btn = document.getElementById(`ProductSubmitButton-${this.dataset.sectionId}`);
          if (!btn) return;
          const quantityForm = document.getElementById(`Quantity-Form-${this.dataset.sectionId}`);
          this._observer = new MutationObserver(() => {
            // The button is disabled for an unpicked variant too, which is
            // nothing to sign up for.
            const soldOut = btn.hasAttribute('disabled') && !btn.hasAttribute('data-awaiting-selection');
            this.style.display = soldOut ? 'block' : 'none';
            btn.style.display = soldOut ? 'none' : '';
            if (quantityForm) quantityForm.style.display = soldOut ? 'none' : '';
          });
          this._observer.observe(btn, { attributes: true, attributeFilter: ['disabled'] });
        };

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', init, { once: true });
        } else {
          init();
        }
      }

      disconnectedCallback() {
        this._observer?.disconnect();
        this._variantChangeUnsubscriber?.();
      }

      onSubmitKeydown(event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.onSubmit();
        }
      }

      onEmailKeydown(event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.onSubmit();
        }
      }

      resetForm() {
        if (this.formEl) this.formEl.hidden = false;
        if (this.successEl) this.successEl.hidden = true;
        this.setSubmitDisabled(false);
      }

      setSubmitDisabled(disabled) {
        if (!this.submitEl) return;
        this.submitEl.classList.toggle('is-disabled', disabled);
        this.submitEl.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      }

      onSubmit() {
        if (this._submitting) return;

        const email = this.emailInput?.value.trim();
        if (!email || !this.emailInput.checkValidity()) {
          this.emailInput?.reportValidity();
          return;
        }

        const companyId = this.dataset.klaviyoCompanyId;
        const variantId = this.dataset.variantId;
        if (!companyId || !variantId) {
          console.warn('BackInStockForm: missing Klaviyo company id or variant id.');
          return;
        }

        const payload = {
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email },
                },
              },
              channels: ['EMAIL'],
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: `$shopify:::$default:::${variantId}`,
                },
              },
            },
          },
        };

        this._submitting = true;
        this.setSubmitDisabled(true);

        fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${companyId}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: '2024-06-15',
          },
          body: JSON.stringify(payload),
        })
          .then((response) => {
            console.log('Klaviyo back-in-stock response:', response);
            if (!response.ok) throw new Error(`Klaviyo responded with ${response.status}`);
            if (this.formEl) this.formEl.hidden = true;
            if (this.successEl) this.successEl.hidden = false;
          })
          .catch((error) => {
            console.error('Klaviyo back-in-stock subscribe error:', error);
            this.setSubmitDisabled(false);
          })
          .finally(() => {
            this._submitting = false;
          });
      }
    }
  );
}
